import { useEffect } from "react";

const HIRING_WIDGET_SCRIPT_URL =
  "https://chatbot.ancileservices.in/hiring-widget.js";

const readLoggedInUserFromStorage = () => {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return null;
    const user = JSON.parse(raw);
    return user && typeof user === "object" ? user : null;
  } catch {
    return null;
  }
};

const resolveLoggedInUserId = (user = {}) =>
  String(user?.userId ?? user?.id ?? user?.Id ?? "").trim();

const AncileHiringWidget = () => {
  useEffect(() => {
    if (!localStorage.getItem("authUser")) return;

    const loggedInUser = readLoggedInUserFromStorage();
    if (!loggedInUser) return;

    const userId = resolveLoggedInUserId(loggedInUser);
    if (!userId) return;

    const initWidget = () => {
      window.AncileHiring?.init?.({
        id: userId,
        name: String(loggedInUser?.name ?? "").trim(),
        role: String(loggedInUser?.userTypeName ?? "").trim(),
      });
    };

    if (window.AncileHiring?.init) {
      initWidget();
      return;
    }

    const existingScript = document.querySelector(
      `script[src="${HIRING_WIDGET_SCRIPT_URL}"]`
    );

    if (existingScript) {
      existingScript.addEventListener("load", initWidget);
      return () => existingScript.removeEventListener("load", initWidget);
    }

    const script = document.createElement("script");
    script.src = HIRING_WIDGET_SCRIPT_URL;
    script.defer = true;
    script.onload = initWidget;
    document.body.appendChild(script);

    return () => {
      script.onload = null;
    };
  }, []);

  return null;
};

export default AncileHiringWidget;
